import React from 'react';
import moment from 'moment';
import { isNil } from 'lodash';
import { compose, withStateHandlers } from 'recompose';
import { Link } from 'react-router-dom';
import { CampaignType } from '@mm/state/model/CampaignsModel';
import * as routes from '../../../../../common/constants/routes';
import './ChatBlastReportCommon.scss';
import { BotBuilderRoutes } from '../../../../../routes/bot-builder-routes';
import customersLogo from 'assets/logo-customers-blue.svg';

type OuterProps = {
  blast: CampaignType;
  botId: number;
};

type StateProps = {
  time: string;
  audienceRoute: string | null;
  pageRoute: string;
  audienceName: string;
  pageName: string;
  deliveryTypeText?: string;
};

type InnerProps = StateProps;

type Props = OuterProps & InnerProps;

const initialState = (props: OuterProps) => {
  const {
    blast: {
      schedulersAttributes,
      scheduleType,
      createdAt,
      audienceId,
      audienceName,
    },
    botId,
  } = props;
  const scheduledAt = schedulersAttributes
    ? schedulersAttributes[0].scheduledAt
    : null;
  const destinationPageId = schedulersAttributes
    ? schedulersAttributes[0].destinationPageId
    : null;
  const destinationPageName = schedulersAttributes
    ? schedulersAttributes[0].destinationPageName
    : null;

  const time = scheduleType === 'none' ? createdAt : scheduledAt;

  const audienceRoute = isNil(audienceId)
    ? null
    : BotBuilderRoutes.audiences.getLink({ chatbotId: botId, audienceId });
  const pageRoute = `${routes.CHATBOT_EDITOR}/${botId}/build/${destinationPageId}`;

  const deliveryTypeText =
    scheduleType === 'timezone'
      ? "receipient's timezone"
      : scheduleType === 'global'
      ? 'your timezone'
      : '';

  return {
    time:
      scheduleType === 'timezone' && time
        ? moment(time).utc().format('MMM D, YYYY h:mm a')
        : time
        ? moment(time).format('MMM D, YYYY h:mm a')
        : null,
    audienceRoute,
    pageRoute,
    audienceName,
    pageName: destinationPageName,
    deliveryTypeText,
  };
};

const stateUpdaters = {};

const enhance = compose<InnerProps, OuterProps>(
  withStateHandlers(initialState, stateUpdaters),
);

const ChatBlastReportCommon = (props: Props) => {
  const {
    blast: { name, contactsCount },
    time,
    audienceRoute,
    audienceName,
    deliveryTypeText,
  } = props;
  return (
    <div className="blast-report-common">
      <div className="blast-report-common__name">
        <strong>Report name:</strong> {name}
      </div>
      <div className="blast-report-common__recipients">
        <strong>Chat Blast to:</strong> {contactsCount} Recipients
      </div>
      <div className="blast-report-common__links">
        <div className="blast-report-common__link">
          <span className="blast-report-common__link-label">
            <strong>Audience:</strong>
          </span>
          {audienceRoute === null && (
            <span className="blast-report-common__link-label">
              {audienceName}
            </span>
          )}
          {audienceRoute !== null && (
            <Link to={audienceRoute} className="blast-report-common__link-item">
              {audienceName}
            </Link>
          )}
        </div>
      </div>
      <div className="blast-report-common__delivered">
        <strong>Delivered:</strong> {time} {deliveryTypeText}
      </div>
      <div className="blast-report-common__logo-wrapper">
        <div className="blast-report-common__logo-box">
          <img
            className="blast-report-common__logo"
            src={customersLogo}
            alt="Logo"
          />
        </div>
        <span className="blast-report-common__logo-text">Customers.ai</span>
      </div>
    </div>
  );
};

export default enhance(ChatBlastReportCommon);
